// Rewind — "Keep playing" inside The Curve. Draw a player's real value
// history from memory instead of the future. Own guest identity (separate
// from Curve's) since a Rewind draw and a Curve draw are different games
// that shouldn't collide on one token.

const GUEST_KEY = 'ftRewindGuest';

export function getGuestToken() {
  try {
    let token = localStorage.getItem(GUEST_KEY);
    if (!token) {
      token =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `g-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(GUEST_KEY, token);
    }
    return token;
  } catch (e) {
    return null; // storage blocked — server will reject locks without identity
  }
}

export function clearGuestToken() {
  try {
    localStorage.removeItem(GUEST_KEY);
  } catch (e) {
    /* noop */
  }
}

const REQUEST_TIMEOUT_MS = 15000;

async function request(path, options = {}) {
  const guest = getGuestToken();
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  let res;
  try {
    res = await fetch(`/api/rewind${path}`, {
      credentials: 'include',
      ...options,
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        ...(guest ? { 'x-ft-rewind-guest': guest } : {}),
        ...(options.headers || {}),
      },
    });
  } catch (e) {
    throw e.name === 'AbortError' ? new Error('Request timed out') : e;
  } finally {
    clearTimeout(timer);
  }
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body;
}

export const startRound = () => request('/start', { method: 'POST', body: JSON.stringify({}) });
export const submitRound = (lineId, points) =>
  request('/play', { method: 'POST', body: JSON.stringify({ lineId, points }) });
export const claimGuestDraws = (guestToken) =>
  request('/claim', { method: 'POST', body: JSON.stringify({ guestToken }) });
